import React, { Component } from "react";
import { connect } from "react-redux";
import ConfirmSaveDialog from "../../../shared/ConfirmSaveDialog";

import { togglePlanConfirmPopup } from "../../../../business/actions/applicationActions";
import { selectOpenPlanConfirmPopup } from "../../../../business/selectors/applicationSelectors";

class ConfirmPlanSaveDialog extends Component {
  handleOk = () => {
    if (typeof this.props.onOk === "function") {
      this.props.onOk();
    }
    this.props.toggle();
  };

  handleCancel = () => {
    this.props.toggle();
  };

  render() {
    const { open } = this.props;
    return (
      <ConfirmSaveDialog
        open={open}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
      />
    );
  }
}

const mapStateToProps = state => ({
  open: selectOpenPlanConfirmPopup(state)
});

const mapDispatchToProps = dispatch => ({
  toggle: () => dispatch(togglePlanConfirmPopup())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmPlanSaveDialog);
